module.exports = __webpack_public_path__ + "img/iot4.9f00b3f8.png";